'use strict';

class PreviousChoiceSetter {
    constructor() {
        this.collapseds = document.getElementsByClassName('collapsed');
        this.cancelButtons = document.getElementsByClassName('cancel-button');
        this.previousInputs = [];

        this.setUpListeners();
    }

    setUpListeners() {
        for (let i = 0; i < this.collapseds.length; i++) {
            this.collapseds[i].addEventListener('click', (event) => {
                this.getPreviousInputs(event);
            }, false);
        }

        for (let i = 0; i < this.cancelButtons.length; i++) {
            this.cancelButtons[i].addEventListener('click', (event) => {
                this.setPreviousInputs(event);
            }, false);
        }
    }

    cardIsOpened(card) {
        return !card.classList.contains('collapsed');
    }

    isRadioInput(input) {
        return input.tagName === 'INPUT' && input.type === 'radio';
    }

    isCheckboxInput(input) {
        return input.tagName === 'INPUT' && input.type === 'checkbox';
    }

    isTextInput(input) {
        return input !== undefined && input.tagName === 'INPUT' && input.type === 'text';
    }

    isSelectInput(input) {
        return input !== undefined && input.tagName === 'SELECT';
    }

    createInputObject(htmlInput) {
        let input = {
            id: null,
            type: null,
            value: null,

            setId() {
                this.id = htmlInput.id;
            },

            setType() {
                if (this.isRadioInput()) {
                    this.type = htmlInput.type;
                }

                if (this.isCheckboxInput()) {
                    this.type = htmlInput.type;
                }

                if (this.isTextInput()) {
                    this.type = htmlInput.type;
                }

                if (this.isSelectInput()) {
                    this.type = 'select';
                }
            },

            setValue() {
                switch (this.type) {
                    case 'radio':
                        (htmlInput.checked) ? this.value = true : this.value = false;
                        break;
                    case 'checkbox':
                        (htmlInput.checked) ? this.value = true : this.value = false;
                        break;
                    case 'text':
                        this.value = htmlInput.value;
                        break;
                    case 'select':
                        this.value = htmlInput.selectedIndex;
                        break;
                }
            },

            isRadioInput() {
                return htmlInput.tagName === 'INPUT' && htmlInput.type === 'radio';
            },

            isCheckboxInput() {
                return htmlInput.tagName === 'INPUT' && htmlInput.type === 'checkbox'
            },

            isTextInput() {
                return htmlInput !== undefined && htmlInput.tagName === 'INPUT' && htmlInput.type === 'text';
            },

            isSelectInput() {
                return htmlInput !== undefined && htmlInput.tagName === 'SELECT';
            },
        };

        input.setId();
        input.setType();
        input.setValue();

        return input;
    }

    getPreviousInputsData(inputs) {
        for (let i = 0; i < inputs.length; i++) {
            let input = this.createInputObject(inputs[i]);

            this.previousInputs.push(input);
        }
    }

    getPreviousInputs(event) {
        if (this.cardIsOpened(event.target)) {
            return;
        }

        this.previousInputs = [];

        let currentCard = event.target.closest('div.card');
        let inputs = Array.from(currentCard.getElementsByClassName('card-body')[0].getElementsByTagName('input'));
        let select = Array.from(currentCard.getElementsByClassName('card-body')[0].getElementsByTagName('select'));

        inputs.push(...select);

        this.getPreviousInputsData(inputs);
    }

    inputStatusHasChanged(i, input) {
        return this.previousInputs[i].value !== input.checked;
    }

    setRadioPreviousData(input) {
        (input.checked) ? input.checked = false : input.checked = true;
    }

    setCheckboxPreviousData(input) {
        input.click();
    }

    setTextInputPreviousData(input, i) {
        input.value = this.previousInputs[i].value;
    }

    setSelectInputPreviousData(input, i) {
        input.selectedIndex = this.previousInputs[i].value;
    }

    setPreviousInputsData(inputs) {
        for (let i = 0; i < this.previousInputs.length; i++) {
            if (this.isRadioInput(inputs[i])) {
                if (this.inputStatusHasChanged(i, inputs[i])) {
                    this.setRadioPreviousData(inputs[i]);
                }
            }
            if (this.isCheckboxInput(inputs[i])) {
                if (this.inputStatusHasChanged(i, inputs[i])) {
                    this.setCheckboxPreviousData(inputs[i]);
                }
            }

            if (this.isTextInput(inputs[i])) {
                this.setTextInputPreviousData(inputs[i], i);
            }

            if (this.isSelectInput(inputs[i])) {
                this.setSelectInputPreviousData(inputs[i], i)
            }
        }
    }

    setPreviousInputs(event) {
        let currentCard = event.target.closest('div.card');
        let inputs = Array.from(currentCard.getElementsByClassName('card-body')[0].getElementsByTagName('input'));
        let select = Array.from(currentCard.getElementsByClassName('card-body')[0].getElementsByTagName('select'));

        inputs.push(...select);

        this.setPreviousInputsData(inputs);
    }
}

export default PreviousChoiceSetter;



// WEBPACK FOOTER //
// ./assets/js/utils/previous-choice-setter.js